<script>
    import { t, dt, languageStore } from 'totalinvoice-frontend-core'
    import { DataGrid } from 'totalinvoice-frontend-core'

    export let id
    export let userList

    const labels = [
        'E-mail',
        'First name',
        'Last name',
        'Created',
        'E-mail verified',
        '',
    ]

    const columns = [
        { data: 'email' },
        { data: 'firstName' },
        { data: 'lastName' },
        { data: 'createdTimestamp', render: (_data, _type, row) => $dt(new Date(row.createdTimestamp)) },
        { data: 'emailVerified', render: (_data, _type, row) => row.emailVerified === true ? $t('Yes') : $t('No') },
        { data: 'id', sortable: false, render: (_data, _type, row) => `<a href="/admin/users/${row.id}">${$t("Details")}</a>` },
    ]

    const order = [
        [ 0, 'asc' ]
    ]
</script>

{#if userList && userList.length > 0}
    <DataGrid
        {id}
        language={$languageStore.selected}
        {labels}
        {columns}
        data={userList}
        ordering={true},
        {order}
    />
{:else}
    <div class="has-text-centered pt-5">
        <p>
            <span class="icon is-large has-text-grey-light">
                <i class="fas fa-users fa-5x" />
            </span>
        </p>
        <h5 class="subtitle is-5 mt-3">{$t('No users found')}</h5>
    </div>
{/if}
